import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const K = {
  ink: "#004058",
  mid: "#4A6B7C",
  lt: "#94A3B8",
  sur: "#FFFFFF",
  bg: "#F8FAFC",
  brd: "#E2E8F0",
  alt: "#F1F5F9",
  red: "#EF4444",
  grn: "#10B981",
  mp: "#009EE3",
  r: { s: 6, m: 10, p: 14, l: 20, xl: 24, xxl: 32 },
  sh: { 
    s: "0 1px 4px rgba(0,0,0,.05)", 
    m: "0 4px 16px rgba(0,0,0,.08)", 
    l: "0 12px 40px rgba(0,0,0,.11)", 
    xl: "0 24px 72px rgba(0,0,0,.16)" 
  }
};

export default function TermsOfUse() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: K.bg, fontFamily: "'Open Sans', sans-serif" }}>
      
      {/* Header Fixo */}
      <nav style={{
        background: "rgba(255,255,255,0.9)", backdropFilter: "blur(10px)", 
        borderBottom: `1px solid rgba(0,0,0,0.05)`, padding: "0 24px", height: 70, 
        display: "flex", alignItems: "center", justifyContent: "space-between", 
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 50
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <span 
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: 24, fontWeight: 800, color: K.ink, cursor: "pointer" }} 
            onClick={() => navigate("/")}
          >
            Eventos<span style={{ color: "#009EE3" }}>&</span>Encontros
          </span>
        </div>
        <button 
          onClick={() => navigate("/")}
          style={{
            background: K.alt, color: K.ink, border: "none", padding: "8px 16px", 
            borderRadius: K.r.m, fontWeight: 700, cursor: "pointer", fontSize: 13
          }}
        >
          Voltar para Início
        </button>
      </nav>

      {/* Hero Section */}
      <header style={{
        background: `linear-gradient(135deg, ${K.ink} 0%, #001f2b 100%)`,
        padding: "140px 24px 80px",
        color: "#fff",
        textAlign: "center"
      }}>
        <div className="fu" style={{ maxWidth: 700, margin: "0 auto" }}>
          <div style={{
            display: "inline-block", background: "rgba(255,255,255,0.1)", 
            padding: "6px 14px", borderRadius: 100, fontSize: 13, 
            fontWeight: 600, marginBottom: 20, letterSpacing: 1
          }}>
            REGRAS DE UTILIZAÇÃO
          </div>
          <h1 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "clamp(32px, 5vw, 48px)", fontWeight: 800, marginBottom: 24, lineHeight: 1.2 }}>
            Termos de Uso
          </h1>
          <p style={{ fontSize: 18, opacity: 0.8, lineHeight: 1.6 }}>
            Ao acessar e utilizar nossa plataforma, você concorda com as condições abaixo.
          </p>
        </div>
      </header>

      {/* Conteúdo */}
      <main style={{ maxWidth: 800, margin: "-40px auto 100px", padding: "0 24px", position: "relative", zIndex: 10 }}>
        
        <div className="fu2" style={{
          background: K.sur, borderRadius: K.r.xl, boxShadow: K.sh.l, padding: "40px clamp(20px, 5vw, 50px)"
        }}>
          
          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              1. Aceite dos Termos
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              O acesso e uso da plataforma Eventos e Encontros estão sujeitos à aceitação destes Termos de Uso. Ao navegar pelo site, realizar cadastro ou adquirir ingressos, você declara que leu, compreendeu e concordou plenamente com todas as regras aqui dispostas.
            </p>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              2. Natureza dos Serviços (Plataforma Tecnológica)
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              O Eventos e Encontros atua puramente como uma <strong>plataforma facilitadora tecnológica (SaaS)</strong>. Nós fornecemos a infraestrutura para a venda de ingressos e gestão de eventos. A organização, execução, qualidade, segurança, mudanças de datas ou cancelamento dos eventos divulgados são de <strong>exclusiva responsabilidade dos respectivos organizadores</strong> (promotores de cada evento).
            </p>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              3. Aquisição de Ingressos e Pagamento
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15, marginBottom: 12 }}>
              Todas as transações financeiras são processadas por empresas terceirizadas de pagamento seguras (ex: Mercado Pago). A plataforma poderá cobrar uma taxa de serviço (conveniência) pelo uso da tecnologia de gestão e emissão online, a qual será exibida de forma transparente antes da finalização da compra.
            </p>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              O ingresso é nominal e vinculado à sua conta. É terminantemente proibida a revenda de ingressos (cambismo).
            </p>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              4. Cancelamentos e Responsabilidades
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              Consulte nossa <span onClick={() => navigate("/politica-devolucao")} style={{color: K.mp, cursor:"pointer", fontWeight: 600}}>Política de Devolução</span> para detalhes sobre o prazo legal de arrependimento (7 dias). Em caso de adiamento ou cancelamento do evento por parte da organização, as regras de reembolso ou reagendamento seguirão a legislação vigente e as orientações da produção do evento. A plataforma se compromete a facilitar o estorno via Gateway de pagamento nestes casos.
            </p>
          </section>

          <section>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              5. Modificação dos Termos
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              A plataforma reserva-se o direito de alterar, suspender ou descontinuar serviços a qualquer momento, bem como atualizar estes termos. Recomendamos que reveja esta página periodicamente. O uso continuado após alterações indica aceitação.
            </p>
          </section>

        </div>
      </main>

    </div>
  );
}
